import { Column, Display, IEntity } from "@messaia/cdk";
import { PendingPhoneNumberOperation } from "../enums/pending-phone-number-operation";
import { PhoneNumber } from "./phone-number";

export class AssignedNumber implements IEntity {
    @Column({ name: 'phoneNumber.nationalDestinationCode', maxWidth: 70 })
    @Display($localize`:@@phoneNumberPrefix:Phone number prefix`)
    private nationalDestinationCode: string;

    @Column({ name: 'phoneNumber.subscriberNumber', maxWidth: 95 })
    @Display($localize`:@@phoneNumber:Phone number`)
    private subscriberNumber: string;

    @Column({ name: 'phoneNumber.blockEnd', maxWidth: 95 })
    @Display($localize`:@@blockEnd:Block end`)
    private blockEnd: string;

    @Column({ name: 'phoneNumber.blockCount', maxWidth: 90, showGtMd: true })
    @Display($localize`:@@blockCount:Block count`)
    private blockCount: number;

    @Column({ showGtMd: true })
    @Display($localize`:@@userName:Username`)
    userName: string;

    @Column({ maxWidth: 90, showGtMd: true })
    @Display($localize`:@@password:Password`)
    password: string;

    phoneNumber: PhoneNumber;

    @Column({ maxWidth: 90, showGtLg: true })
    @Display($localize`:@@status:Status`)
    status: string;

    pendingOperation: PendingPhoneNumberOperation;
    imported: boolean;
    exported: boolean;
    returned: boolean;
    workflowId: string;

    @Column({ index: 1001, header: $localize`:@@id:ID`, arrowBefore: true, showGtMd: true })
    id: number;
}